import TextField from '@material-ui/core/TextField'
import React from 'react'
import { connect } from 'react-redux'
import ExpandableListElement from '../../components/controls/ExpandableListElement'
import InformacjeUszczegolawiajaceStyle from '../../styles/InformacjeUszczegolawiajaceStyle'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'
import Szambelan from '../../components/Szambelan'
import InfoPanel from '../../components/InfoPanel'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

class InformacjeUszczegolawiajace extends React.Component {
  state = {
    activeIndex: -1,
  }

  handleToggleActive = (index) => {
    this.setState({ activeIndex: index })
  }

  rolledContent = () => {
    return (
      <div>
        W tym miejscu można dodać informacje uszczegóławiające, wynikające z
        potrzeb lub specyfiki jednostki. <br />
        Informacje te są opcjonalne.
      </div>
    )
  }

  render() {
    const {
      onSetSectionDataArray,
      section,
      validityErrors,
      czyPodsumowanie,
    } = this.props
    const struktura = {
      Opis: '',
      Nazwa: '',
    }
    return (
      <MainStyle
        className={section.Dane.Pozycje.length > 0 ? '' : 'hide-on-print'}
      >
        <InfoPanel canExpand={false} rolledContent={this.rolledContent()} />
        <InformacjeUszczegolawiajaceStyle>
          <div className="attachment-header">
            <span>INFORMACJE USZCZEGÓŁAWIAJĄCE</span>
            <ButtonAddInfo label="DODAJ INFORMACJĘ" structure={struktura} />
          </div>
          {section.Dane.Pozycje.length > 0 ? (
            <div className="container">
              <div className="listLabel caption">
                <p>NAZWA POZYCJI</p>
              </div>
              {section.Dane.Pozycje.map((data, index) => (
                <ExpandableListElement
                  placeholder="Nazwa pozycji"
                  nazwaPozycji={data.Nazwa}
                  isActive={this.state.activeIndex === index}
                  key={index}
                  index={index}
                  hasError={(name, value) =>
                    controlHasError(validityErrors, name, value, true)
                  }
                  helperText="Minimum 2 znaki, maksimum 250 znaków"
                >
                  <div className="header">
                    <p>TREŚĆ INFORMACJI</p>
                  </div>
                  <form autoComplete="off" className="subsection">
                    {czyPodsumowanie ? (
                      <PrintText text={data.Opis} />
                    ) : (
                      <TextField
                        className="textarea"
                        name="Opis"
                        placeholder="Wpisz tutaj treść informacji..."
                        multiline
                        variant="outlined"
                        title={data.Opis}
                        value={data.Opis}
                        error={controlHasError(
                          validityErrors,
                          'Opis',
                          data.Opis,
                          true,
                        )}
                        onChange={(e) => onSetSectionDataArray(e, index)}
                        onFocus={() => this.handleToggleActive(index)}
                        onBlur={() => this.handleToggleActive(-1)}
                      />
                    )}
                  </form>
                </ExpandableListElement>
              ))}
            </div>
          ) : (
            <Szambelan
              text={
                <>
                  Nie masz opcjonalnych
                  <br /> informacji uszczegóławiających
                </>
              }
            />
          )}
        </InformacjeUszczegolawiajaceStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors.filter(
          (value) => value.TypSekcji === 'InformacjeSzczegolowe',
        )
      : [],
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionDataArray: (e, index) => {
      let { value, name } = e.target
      dispatch(actions.setSectionDataArray(value, index, 0, name))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InformacjeUszczegolawiajace)
